// extracted by mini-css-extract-plugin
export var banner = "_rh-0";
export var settingRow = "_rh-2";
export var titleIcon = "_rh-1";